export function Menu() {
  const MenuBtn = $('.Header_menuBtn');
  const Menu = $('.Header_wrap.-main');
  const Body = $('body');


  function menuReset() {
    Menu.removeClass('-opened');
    Menu.removeAttr('aria-hidden');
    Menu.css('display','');
  }
  function menuBtnReset() {
    MenuBtn.attr('aria-selected','false');
  }

  // Menuの開閉
  function MenuOpen() {
    Menu.attr('aria-hidden','false');
    Menu.addClass('-opened');
    Menu.fadeIn();
  }
  function MenuClose() {
    Menu.attr('aria-hidden','true');
    Menu.removeClass('-opened');
    Menu.fadeOut();
  }

  // Menu ButtonのARIA属性値
  function changeButtonClose() {
    MenuBtn.attr('aria-selected','false');
  }
  function changeButtonOpen() {
    MenuBtn.attr('aria-selected','true');
  }

  // Bodyのclassコントロール
  let scrollPosition;

  function bodyFixed() {
    scrollPosition = $(window).scrollTop();
    Body.css({'top': scrollPosition});
    Body.addClass('fixed');
  }
  function bodyReset() {
    Body.removeClass('fixed');
    Body.css({'top': 'auto'});
    $('html, body').scrollTop(scrollPosition);
  }

  // Menu ButtonクリックでMenuオープン
  function toggleMenu() {
    MenuBtn.click(function () {
      if($(this).attr('aria-selected') === 'false') {
        MenuOpen();
        changeButtonOpen();
        bodyFixed();
      } else {
        MenuClose();
        changeButtonClose();
        bodyReset();
      }
    });
  }

  // ロード時とリサイズ時にリセット
  $(window).on('load', function () {
    menuReset();
    bodyReset();
    menuBtnReset();
  });
  $(window).on('resize', function () {
    menuReset();
    bodyReset();
    menuBtnReset();
  });

  $(function () {
    toggleMenu();
  })
}